import LinearProgress from "@material-ui/core/LinearProgress";

const InfoAfterConfirm = ({ toSendIndex, toSendList }) => {
  let index = 0;
  if (toSendIndex) index = toSendIndex + 1;
  return (
    <div>
      <p>
        {toSendIndex === toSendList.length ? (
          <strong style={{ color: "green" }}> Done</strong>
        ) : (
          <span>
            {index} out of {toSendList.length}
            <LinearProgress mode="indeterminate" />
          </span>
        )}
      </p>
    </div>
  );
};

export default InfoAfterConfirm;
